import Fuse from "fuse.js";
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import BackgroundOverlay from "../../framework/BackgroundOverlay";
import GlobalContext from "../../framework/GlobalContext";
import TextInput from "../../framework/TextInput";

import { SUPPORT_CONTACT1, SUPPORT_EMAIL1 } from "../../utils/constant";

import spotlightIcons from "../../assets/images/spotlight";

import { InputAdornment } from "@mui/material";
import { debounce } from "lodash";
import images from "../../assets/images";
import {
  BANK_TAB,
  CUSTOMER_TAB,
  DISTRIBUTOR_TAB,
  DOCTORS_TAB,
  ENTITY_TAB,
  GENERATE_OTP_TAB,
  HEALTH_STATUS_TAB,
  HSN_TAB,
  PRODUCTS_TAB,
  ROLES_TAB,
  STOCK_AUDIT_TAB,
  USERS_TAB,
  REPORTS_STOCK_AUDIT,
  REPORTS_STOCK_TRANSFER,
  REPORTS_STOCK_REQUEST,
  REPORTS_MEDICINE_WISE_STOCK_AUDIT,
  TRANSPORTATION_TAB,
  PROFESSION_TAB,
  SPECIALITY_TAB,
  ADD_SYSTEM_TAB,
  REPORTS_MEDICINE_WISE_STOCK_TRANSFER,
  REPORTS_MEDICINE_WISE_STOCK_REQUEST,
  REPORTS_DISCOUNT_SLAB,
  REPORTS_DISCOUNT_PROGRAM,
  ADD_SERVICE_ITEM_TAB,
  MANUFACTURER_TAB,
  MANUFACTURER_GROUP_TAB,
  BRANCH_GROUP_TAB,
  RETAILER_REPORTS_TAB,
  REPORTS_FREQUENCY_SLAB_TAB,
  CAC_USER_TAB,
  CAC_ROLES_TAB,
} from "../../framework/tab/tabUtilsConstants";
import { formatNumber, getStringValue } from "../../utils/utils";
import { canAccessScreen } from "../../utils/accessUtils";
import Menu from "./Menu";
import classes from "./Spotlight.module.css";

const Spotlight = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [evaluatedString, setEvaluatedString] = useState(null);
  const [searchResult, setSearchResult] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const spotlightSearchInputRef = useRef();
  const listRef = useRef(null);
  const { searchIcon } = images;
  const {
    showSpotlight,
    currentComponent,
    setCurrentComponent,
    setShowSpotlight,
    setAddNewTab,
    showAddProductAutocomplete,
  } = useContext(GlobalContext);

  const makeScreen = useCallback(
    (title, search, component, menu_icon = spotlightIcons.reportsActiveIcon) => ({
      type: "screen",
      menu_icon,
      title,
      search,
      component,
      action: () => setAddNewTab({ component }),
    }),
    [setAddNewTab]
  );

  const search_screens = useMemo(() => {
    const screens = [
      makeScreen("Users", "users", USERS_TAB),
      makeScreen("Products Master", "productsmaster", PRODUCTS_TAB),
      makeScreen("Doctor Master", "doctormaster", DOCTORS_TAB),
      makeScreen("HSN Master", "hsn", HSN_TAB),
      makeScreen("Distributor Master", "distributormaster", DISTRIBUTOR_TAB),
      makeScreen("Entity/Family Master", "entitymaster", ENTITY_TAB),
      makeScreen("Customer Master", "customermaster", CUSTOMER_TAB),
      makeScreen("Bank Master", "bankmaster", BANK_TAB),
      makeScreen("Transport Master", "transportmaster", TRANSPORTATION_TAB),
      makeScreen("Roles", "roles", ROLES_TAB),
      makeScreen("Retailer", "retailer", RETAILER_REPORTS_TAB),
      makeScreen("Generate OTP", "generateotp", GENERATE_OTP_TAB, spotlightIcons.moreIcon),
      makeScreen("Health Status", "healthstatus", HEALTH_STATUS_TAB, spotlightIcons.doctorActiveIcon),
      makeScreen("System", "system", ADD_SYSTEM_TAB, spotlightIcons.doctorActiveIcon),
      makeScreen("Stock Audit", "stockaudit", STOCK_AUDIT_TAB),
      makeScreen("Stock Audit Report", "stockauditreport", REPORTS_STOCK_AUDIT),
      makeScreen("Stock Transfer Report", "stocktransferreport", REPORTS_STOCK_TRANSFER),
      makeScreen("Stock Request Report", "stockrequestreport", REPORTS_STOCK_REQUEST),
      makeScreen(
        "Medicine Wise Stock Audit Report",
        "medicinewisestockauditreport",
        REPORTS_MEDICINE_WISE_STOCK_AUDIT
      ),
      makeScreen("Discount Slab Report", "discountslabreport", REPORTS_DISCOUNT_SLAB),
      makeScreen(
        "Discount Program Report",
        "discountprogramreport",
        REPORTS_DISCOUNT_PROGRAM
      ),
      makeScreen("Profession Master", "professionmaster", PROFESSION_TAB),
      makeScreen(
        "Medicine Wise Stock Transfer Report",
        "medicinewisestocktransferreport",
        REPORTS_MEDICINE_WISE_STOCK_TRANSFER
      ),
      makeScreen(
        "Medicine Wise Stock Request Report",
        "medicinewisestockrequestreport",
        REPORTS_MEDICINE_WISE_STOCK_REQUEST
      ),
      makeScreen("Service Item Master", "serviceitemmaster", ADD_SERVICE_ITEM_TAB),
      makeScreen("Manufacturer Master", "manufacturermaster", MANUFACTURER_TAB),
      makeScreen(
        "Manufacturer Group Master",
        "manufacturergroupmaster",
        MANUFACTURER_GROUP_TAB
      ),
      makeScreen("Branch Group Master", "branchgroupmaster", BRANCH_GROUP_TAB),
      makeScreen("Speciality Master", "specialitymaster", SPECIALITY_TAB),
      makeScreen("Frequency Slab Report", "frequencyslabreport", REPORTS_FREQUENCY_SLAB_TAB),
      makeScreen("CAC Users", "cacuser", CAC_USER_TAB),
      makeScreen("CAC Users Roles", "cacusersroles", CAC_ROLES_TAB),
    ];
    return screens.filter((screen) => canAccessScreen(screen.component));
  }, [makeScreen]);

  const fetchSearchResults = useCallback(
    (searchTerm) => {
      const options = {
        shouldSort: true,
        findAllMatches: true,
        includeScore: true,
        threshold: 0.4,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: ["title", "search"],
      };

      const fuse = new Fuse(search_screens, options);
      const fuse_result = fuse.search(searchTerm);
      let core_screen = [];
      let ugly_screen = [];
      fuse_result.forEach((r) => {
        const screen = {
          type: r.item.type,
          menu_icon: r.item.menu_icon,
          title: r.item.title,
          action: r.item.action,
        };
        if (r.score < 0.09 && searchTerm.length / r.item.search.length > 0.4) {
          core_screen.push(screen);
        } else {
          ugly_screen.push(screen);
        }
      });
      setSearchResult([...core_screen, ...ugly_screen]);
    },
    [search_screens]
  );
  const listClickHandler = useCallback(
    (index) => {
      setActiveIndex(index);
      const result = searchResult[index];
      if (result.type === "screen") {
        result.action();
        setShowSpotlight(false);
        return;
      }
    },
    [searchResult, setShowSpotlight]
  );

  const spotlightSearchHandler = useCallback(
    (e) => {
      setSearchTerm(e.target.value);
      if (e.target.value.length > 2) {
        let computedValue = null;
        try {
          // eslint-disable-next-line no-eval
          computedValue = eval(e.target.value);
          if (typeof computedValue === "number")
            setEvaluatedString(getStringValue(computedValue));
        } catch (e) {
          setEvaluatedString(null);
        }
        debounce(() => fetchSearchResults(e.target.value), 300)();
      } else {
        setEvaluatedString(null);
        setSearchTerm(null);
      }
    },
    [fetchSearchResults]
  );

  const spotlightSearchListener = useCallback(
    (e) => {
      const key = e.key.toLowerCase();
      if (key === "arrowdown") {
        if (activeIndex === searchResult.length - 1) {
          return;
        }
        setActiveIndex((prev) => prev + 1);
        // executeScroll(listRef);
        return;
      }
      if (key === "arrowup") {
        if (activeIndex === 0) {
          return;
        }
        setActiveIndex((prev) => prev - 1);
        // executeScroll(listRef);
        return;
      }
      if (key === "enter") {
        if (!searchResult?.length) {
          spotlightSearchInputRef.current?.click();
          return;
        }
        listClickHandler(activeIndex);
        return;
      }

      if (key === "escape") {
        setShowSpotlight(false);
        e.stopPropagation();
        return;
      }
    },
    [activeIndex, listClickHandler, searchResult.length, setShowSpotlight]
  );

  useEffect(() => {
    if (showSpotlight) {
      spotlightSearchInputRef.current.focus();
    }
  }, [showSpotlight]);

  useEffect(() => {
    setCurrentComponent("list_nav_spotlight_search_result");
    return () => {
      if (!showAddProductAutocomplete) {
        setCurrentComponent(null);
      }
    };
  }, [setCurrentComponent, showAddProductAutocomplete]);

  useEffect(() => {
    if (currentComponent === "list_nav_spotlight_search_result")
      document.addEventListener("keyup", spotlightSearchListener, false);
    return () => {
      document.removeEventListener("keyup", spotlightSearchListener, false);
    };
  });

  return (
    <>
      <div className={classes["spotlight-container"]}>
        <div className={classes["spotlight-content-container"]}>
          <div className={classes["spotlight-content"]}>
            <div className={classes["spotlight-searchbar"]}>
              <TextInput
                variant="standard"
                placeholder="Search here..."
                ref={spotlightSearchInputRef}
                onChange={spotlightSearchHandler}
                onKeyDown={(e) => {
                  const key = e.key.toLowerCase();
                  if (key === "tab") {
                    e.preventDefault();
                  }
                }}
                InputProps={{
                  // eslint-disable-next-line no-eval
                  startAdornment: (
                    <InputAdornment position="start">
                      <img src={searchIcon} alt="search" />
                    </InputAdornment>
                  ),
                  endAdornment: evaluatedString && (
                    <div
                      className={classes["computed-value"]}
                    >{`= ${formatNumber(evaluatedString, 0, true, "")}`}</div>
                  ),
                }}
              />
            </div>
            {searchTerm && (
              <div className={classes["spotlight-search-result-container"]}>
                <ul>
                  {searchResult?.map((result, index) => {
                    return (
                      <li
                        ref={index === activeIndex ? listRef : null}
                        key={index}
                        onClick={() => listClickHandler(index)}
                        className={`${
                          classes["spotlight-search-result-list-item"]
                        } ${index === activeIndex && classes["active"]}`}
                      >
                        <div
                          className={
                            classes["spotlight-search-result-list-item-content"]
                          }
                        >
                          <img
                            src={result.menu_icon}
                            alt={result.title}
                            width={24}
                            height={24}
                          />
                          <div
                            className={
                              classes["spotlight-search-result-title-container"]
                            }
                          >
                            <div
                              className={
                                classes["spotlight-search-result-title"]
                              }
                            >
                              {result.title}
                            </div>
                            <div
                              className={
                                classes["spotlight-search-result-subtitle"]
                              }
                            >
                              {result.subTitle}
                            </div>
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
            {!searchTerm && (
              <div className={classes["spotlight-tabs-container"]}>
                <Menu />
              </div>
            )}
          </div>
          <div className={classes["spotlight-footer"]}>
            <div className={classes["footer-item"]}>
              <img src={spotlightIcons["callIcon"]} alt="Call Icon" />
              <div className={classes["footer-item-label"]}>
                {SUPPORT_CONTACT1}
              </div>
            </div>
            <div className={classes["footer-item"]}>
              <img src={spotlightIcons["whatsappIcon"]} alt="Chat Icon" />
              <div className={classes["footer-item-label"]}>
                {SUPPORT_CONTACT1}
              </div>
            </div>
            <div className={classes["footer-item"]}>
              <img src={spotlightIcons["gmailIcon"]} alt="Gmail Icon" />
              <div className={classes["footer-item-label"]}>
                {SUPPORT_EMAIL1}
              </div>
            </div>
          </div>
        </div>
      </div>
      <BackgroundOverlay defaultZIndex={999} />
    </>
  );
};

export default Spotlight;
